import { render, staticRenderFns } from "./NewPagination.vue?vue&type=template&id=772ddb56&scoped=true"
import script from "./NewPagination.vue?vue&type=script&lang=js"
export * from "./NewPagination.vue?vue&type=script&lang=js"
import style0 from "./NewPagination.vue?vue&type=style&index=0&id=772ddb56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772ddb56",
  null
  
)

export default component.exports